(function ($, XTT) {
	'use strict';

	function _autoload() {
		$.each(XTT, function (section, obj) {
			if ($.isArray(obj._autoload)) {
				$.each(obj._autoload, function (key, value) {
					if ($.isArray(value)) {
						if (value[1]) {
							XTT[section][value[0]]();
						} else {
							if (value[2]) {
								XTT[section][value[2]]();
							}
						}
					} else {
						XTT[section][value]();
					}
				});
			}
		});
	}

	$(function () {
		_autoload();
	});

})(jQuery, XTT);
